"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var variables_1 = require("../../../config/variables");
var utils_1 = require("../../../utils");
var Icon_1 = require("../../Icon");
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n\n    &:hover,\n    &:focus {\n        outline: none;\n    }\n\n    &:hover {\n        > div:first-child {\n            border: 1px solid ", ";\n        }\n    }\n"], ["\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n\n    &:hover,\n    &:focus {\n        outline: none;\n    }\n\n    &:hover {\n        > div:first-child {\n            border: 1px solid ", ";\n        }\n    }\n"])), function (props) { return props.theme.TYPE_DARK_GREY; });
var IconWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 19px;\n    min-width: 19px;\n    max-width: 19px;\n    height: 19px;\n    border-radius: 3px;\n    box-shadow: ", ";\n    background: ", ";\n    border: 1px solid\n        ", ";\n\n    &:hover,\n    &:focus {\n        ", "\n    }\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 19px;\n    min-width: 19px;\n    max-width: 19px;\n    height: 19px;\n    border-radius: 3px;\n    box-shadow: ",
    ";\n    background: ", ";\n    border: 1px solid\n        ", ";\n\n    &:hover,\n    &:focus {\n        ",
    "\n    }\n"])), function (props) {
    return !props.isChecked ? "inset 0 3px 6px 0 " + props.theme.BG_GREY : "none";
}, function (props) { return (props.isChecked ? props.theme.BG_GREEN : props.theme.BG_WHITE); }, function (props) { return (props.isChecked ? props.theme.TYPE_GREEN : props.theme.TYPE_LIGHT_GREY); }, function (props) {
    return !props.isChecked && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                border: 1px solid ", ";\n            "], ["\n                border: 1px solid ", ";\n            "])), props.theme.TYPE_DARK_GREY);
});
var Label = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    padding-left: 10px;\n    padding-top: 2px;\n    justify-content: center;\n    color: ", ";\n    font-size: ", ";\n    line-height: 18px;\n"], ["\n    display: flex;\n    padding-left: 10px;\n    padding-top: 2px;\n    justify-content: center;\n    color: ", ";\n    font-size: ", ";\n    line-height: 18px;\n"])), function (props) { return props.theme.TYPE_DARK_GREY; }, variables_1.FONT_SIZE.SMALL);
var handleKeyboard = function (event, onClick) {
    if (event.keyCode === 32) {
        onClick(event);
    }
};
var Checkbox = function (_a) {
    var isChecked = _a.isChecked, children = _a.children, onClick = _a.onClick, rest = __rest(_a, ["isChecked", "children", "onClick"]);
    var theme = utils_1.useTheme();
    return (react_1.default.createElement(Wrapper, __assign({ onClick: onClick, onKeyUp: function (event) { return handleKeyboard(event, onClick); }, tabIndex: 0 }, rest),
        react_1.default.createElement(IconWrapper, { isChecked: isChecked }, isChecked && react_1.default.createElement(Icon_1.Icon, { size: 16, color: theme.TYPE_WHITE, icon: "CHECK" })),
        react_1.default.createElement(Label, { isChecked: isChecked }, children)));
};
exports.Checkbox = Checkbox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
